import React, { useState, useCallback, useMemo } from 'react';
import { Dropdown } from '@fluentui/react/lib/Dropdown';
import PropTypes from 'prop-types';

const dropdownStyles = {
  dropdown: {
    width: 120,
    border: 'none',
    boxShadow: 'none',
    outline: 'none',
    selectors: {
      ':focus': {
        outline: 'none',
      },
      ':focus:after': {
        border: 'none',
        outline: 'none',
      },
    },
  },
  title: {
    border: 'none',
    boxShadow: 'none',
    outline: 'none',
    selectors: {
      ':focus': {
        outline: 'none',
        border: 'none',
        boxShadow: 'none',
      },
      ':focus-visible': {
        outline: 'none',
        border: 'none',
        boxShadow: 'none',
      },
    },
  },
  root: {
    border: 'none',
    boxShadow: 'none',
    outline: 'none',
  },
  callout: {
    border: 'none',
    boxShadow: 'none',
    outline: 'none',
  },
  caretDown: {
    border: 'none',
    boxShadow: 'none',
    outline: 'none',
  },
};

function MetricPicker(props) {
  const { metrics, newI18n, updateMetric } = props;

  const [selectedMetric, setSelectedMetric] = useState(metrics[0]);

  const options = useMemo(() => metrics.map(metric => ({
    key: metric.key,
    text: newI18n.getString(metric.i18nKey),
  })), [metrics, newI18n]);

  const handleChange = useCallback((event, option) => {
    const metric = metrics.find(m => m.key === option.key);
    if (updateMetric && metric) {
      updateMetric(metric.key);
    }
    setSelectedMetric(metric);
  }, [metrics, updateMetric]);

  return (
    <Dropdown
      selectedKey={selectedMetric.key}
      options={options}
      onChange={handleChange}
      styles={dropdownStyles}
    />
  );
}

MetricPicker.defaultProps = {
  updateMetric: undefined,
};

MetricPicker.propTypes = {
  metrics: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    i18nKey: PropTypes.string.isRequired,
  })).isRequired,
  updateMetric: PropTypes.func,
  newI18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};

export default MetricPicker;
